import React, { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Collapse from '@material-ui/core/Collapse';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { loadModules } from 'esri-loader';
import { faRoad, faHome, faPlus, faMinus, faTimes, faSearch, faExclamationCircle, } from '@fortawesome/free-solid-svg-icons';
import { Box } from '@material-ui/core';
import Cookies, { set } from 'js-cookie';
import ErrorMessage from '../AppLayouts/ErrorMessage';
import API_PATH from "../../constants/config.json";
import { Typography } from '@material-ui/core';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { clearCookie, setCookie } from '../../functions/Auth';
import { useHistory } from 'react-router-dom';
import LayersIcon from '@material-ui/icons/Layers';

const axios = require('axios');

const API_URL = process.env.REACT_APP_BASE_URL;

//Start Css Code ....
const useStyles = makeStyles((theme) => ({
    root: {
        '& .esri-ui-bottom-right' :{
            padding: "0px 10px 10px 10px",
            right: "30px !important",
              bottom: "14px !important",
          },
        '& .esri-ui-bottom-right' :{
            padding: "0px 10px 10px 10px",
            right: "30px !important",
              bottom: "14px !important",
          },
        flexGrow: 1,
        '& .MuiTextField-root': {
            width: '100%',
            '@media only screen and (min-width: 3501px)': {
                marginBottom: '20px',
            },
            '& input': {
                padding: '10px',
                color: '#333',
                '@media only screen and (max-width: 3500px)': {
                    fontSize: '13pt',
                },
                '@media only screen and (min-width: 3501px)': {
                    fontSize: '23pt',
                },
            },
        }
    },
    paper: {
        padding: '0px 0px',
        boxShadow: 'none',
    },
    fieldsetname: {
        width: 'auto',
        border: '1px solid rgba(0, 167, 93, 1)',
        padding: '10px 10px 25px',
        marginTop: '15px',        
        borderRadius: '5px',
        '& p': {
            margin: '0',
        },
        '& .MuiGrid-item': {
            paddingBottom: '0px',
        }
    },
    fieldsetnameInner: {
        width: '90%',
        border: '1px solid #ccc',
        padding: '10px 10px 25px',
        marginTop: '15px',       
        borderRadius: '5px',
        '& p': {
            margin: '0',
        },
        '& .MuiGrid-item': {
            paddingBottom: '0px',
        }
    },
    selectOption: {
        width: '100%',
        padding: '10px 5px',
        border: '1px solid #c5c5c5',
        background: '#fff',
        borderRadius: '3px',
        color: '#333',
        '@media only screen and (max-width: 3500px)': {
            fontSize: '12pt',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '22pt',
            marginBottom: '20px',
        },
    },
    labelText: {
        width: '100%',
        float: 'left',
        color: '#333',
        '@media only screen and (max-width: 3500px)': {
            fontSize: '14pt',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',
        },
    },
    rootForm: {
        '@media only screen and (max-width: 3500px)': {
            '& h5': {                
                margin: '0',
            }
        },
        '@media only screen and (min-width: 3501px)': {
            '& h5': {
                fontSize: '28pt !important',
                margin: '0',
                marginTop: '10px',
            }
        },
    },
    locationMapView: {
        '& img': {
            width: '100%',
        },
        position:'relative', 
        '@media only screen and (max-width: 3500px)': {
            height: '853px',
        },
        '@media only screen and (min-width: 3501px)': {
            height: '1540px',
        },
    },
    btbBlock: {
        float: 'right',
    },
    btbBlock2: {
        width: '49%',
        textAlign: 'right',
        paddingBottom: '10px',
        '@media only screen and (max-width: 3500px)': {
            marginBottom: '10px',
        },
        '@media only screen and (min-width: 3501px)': {
            marginBottom: '25px',
        },
    },
    addStationBtn: {
        border: '1px solid #24618E',
        color: '#fff',
        background: '#24618E!important',
        '@media only screen and (max-width: 3500px)': {
            fontSize: '14pt',
            width: '150px',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',
            width: '200px',
        },
        '&:hover': {
            boxShadow: '4px 3px 3px 0px #999',
        }
    },
    cancelBtn: {
        border: '1px solid #333',
        color: '#333',
        background: '#fff!important',
        '@media only screen and (max-width: 3500px)': {
            fontSize: '14pt',
            width: '150px',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',
            width: '200px',
        },
        '&:hover': {
            boxShadow: '4px 3px 3px 0px #999',
        }
    },
    importStationFile: {
        border: '1px solid #333',
        color: '#333',
        background: '#fff!important',
        fontSize: '12px',
        width: '200px',
        '&:hover': {
            boxShadow: '4px 3px 3px 0px #999',
        }
    },
    mapViewSection: {
        padding: '0 15px 0px 25px',
        marginTop: '64px',
        '& .hideInteraction': {
            display: 'none',
        },
        '& .hideMidBlock': {
            display: 'none',
        }
    },
    interApprochMainBlock: {
        width: '100%',
        float: 'left',
        '& .inter-left': {
            width: '20%',
            float: 'left',
            paddingRight: '5px',
            paddingBottom: '15px',
        },
        '& .inter-right': {
            width: '78%',
            float: 'right',
            paddingLeft: '5px',
            paddingBottom: '15px',
        }
    },
    homeIcon: {
        position: 'relative',
        color: '#24618E',
        border: '1px solid #24618E',
        background: '#fff',
        textAlign: 'center',
        padding: '5px',
        marginBottom: '10px',
        cursor: 'pointer',
        borderRadius: '5px',
        zIndex: '1',
        '@media only screen and (max-width: 3500px)': {
            width: '40px',
            fontSize: '20px',
        },
        '@media only screen and (min-width: 3501px)': {
            width: '70px',
            height: '65px',
            '& svg': {
                fontSize: '35pt',
            }
        },
    },
    zoomIcon: {
        position: 'relative',
        color: '#24618E',
        border: '1px solid #24618E',
        background: '#fff',
        textAlign: 'center',
        padding: '5px',
        marginBottom: '10px',
        cursor: 'pointer',
        borderRadius: '5px 5px 0px 0px',
        zIndex: '1',
        '@media only screen and (max-width: 3500px)': {
            width: '40px',
            fontSize: '20px',
        },
        '@media only screen and (min-width: 3501px)': {
            width: '70px',
            height: '65px',
            '& svg': {
                fontSize: '35pt',
            }
        },
    },
    inIcon: {
        position: 'relative',
        color: '#24618E',
        border: '1px solid #24618E',
        background: '#fff',
        textAlign: 'center',
        padding: '5px',
        marginBottom: '10px',
        cursor: 'pointer',
        borderRadius: '0px 0px 5px 5px',
        zIndex: '1',
        '@media only screen and (max-width: 3500px)': {
            width: '40px',
            fontSize: '20px',
        },
        '@media only screen and (min-width: 3501px)': {
            width: '70px',
            height: '65px',
            '& svg': {
                fontSize: '35pt',
            }
        },
    },
    mapContainer: {
        width: '100% !important',
        display: 'block !important',
        '@media only screen and (max-width: 3500px)': {
            height: '861px !important'
        },
        '@media only screen and (min-width: 3501px)': {
            height: '1550px !important',
        },
        '& .esri-view-root': {
            height: '100% !important',
            width: '100% !important'
        }
    },
    approachError: {
        marginBottom: '10px',
        '& span': {
            fontSize: '11pt !important'
        },
        '& .MuiPaper-elevation6': {
            flexGrow: 'unset',
            width: '100%'
        }
    },
    rightClickInfo: {
        position: 'absolute',       
        border: '1px solid #24618E',
        textAlign: 'center',
        padding: '5px',
        background: '#f2f2f2',
        borderTop: 'none',
        borderLeft: 'none',
        zIndex: 1,
        '@media only screen and (max-width: 3500px)': {
            width: '400px',
        },
        '@media only screen and (min-width: 3501px)': {
            width: '650px',
            fontSize:'24pt'
        },
    },
    iconBox: {
        position: 'absolute', 
        width: 'max-content',        
        width: 'max-content',        
        paddingLeft: '0px',        
        right: '0',
        '@media only screen and (max-width: 3500px)': {            
            top: '680px'
        },
        '@media only screen and (min-width: 3501px)': {
            top: '1250px'
        },
    },
    layerButton: {
        position: 'absolute',
        right: '5px',
        top: '5px',
        zIndex: 1
    },
    showBtn: {
        color: '#24618E',
        border: '1px solid #24618E',
        fontSize: '12px',
        background: '#fff !important',
        padding: '5px',
        '@media only screen and (max-width: 3500px)': {
          height: '38px',
          minWidth: '40px !important',
        },
        '@media only screen and (min-width: 3501px)': {
          height: '57px',
          minWidth: '60px !important',
        },
      },
    hideBtn: {
        // color: '#24618E',
        // border: '1px solid #24618E',
        fontSize: '12px',
        background: '#24618E !important',
        padding: '5px',
        '@media only screen and (max-width: 3500px)': {
          height: '38px',
          minWidth: '40px !important',
        },
        '@media only screen and (min-width: 3501px)': {
          height: '57px',
          minWidth: '60px !important',
        },
    },
    deleteStation: {
        width: '100%',
        float: 'left',
        textAlign: 'right',
        marginTop: '-50px',
        '& button': {
            border: "1px solid #24618E",
            borderRadius: '5px',
            marginBottom: "10px"
        }
    },
    deletePopup: {
        '& .MuiDialogContent-root': {
            padding: '10px 15px',
        },
        '& .MuiPaper-root': {
            border: '1px solid #24618d',
            width: '525px',
        },
        '& .MuiDialogActions-root': {
            justifyContent: 'center',
            paddingTop: '30px'
        }
    },
    crossIcon: {
        color: '#24618d',
        fontSize: '20pt',
        fontFamily: 'Avenir_Black',
        fontWeight: '800',
        position: 'absolute',
        width: '40px !important',
        right: '5px',
        "&:hover": {
            // color: "#CC0000",
            cursor: 'pointer',
        }
    },
    header: {
        fontWeight: '800',
        color: '#24618d',
        fontFamily: 'Avenir_Black',
        fontSize: '18pt',
    },
    errorMsg: {
        backgroundColor: "#F2DEDE",
        border: "1px solid #CC0000",
        fontFamily: 'Avenir_Black',
        fontSize: '14pt',
        padding: '5px',
        marginBottom: '15px'
        , borderRadius: '5px'
    },
    heading: {
        fontFamily: '"Avenir_light" !important',
        fontSize: '14pt',
        lineHeight: '23px',
    },
    infoErrorIcon: {
        color: '#CC0000',
        fontSize: '25px',
        position: 'relative',
        top: '4px',
        marginRight: '10px',
    },
    clearBtn: {
        border: '1px solid #333',
        color: '#333',
        // fontSize: '12px',
        width: '150px',
        marginRight: '10px',
        textTransform: 'capitalize',
        padding: '3px 5px',
        lineHeight: 'normal',
        letterSpacing: '0',
        '& .MuiButton-root': {
          letterSpacing: '0',
        }
      },
      delBtn: {
        border: '1px solid #24618E',
        color: '#fff',
        background: '#24618E!important',
        width: '150px',
        marginRight: '10px',
        textTransform: 'capitalize',
        padding: '3px 10px',
        lineHeight: 'normal',
        letterSpacing: '0',
        '& .MuiButton-root': {
          letterSpacing: '0',
        }
    },
    btnIcon: {
        '@media only screen and (max-width: 3500px)': {
          fontSize: '20px',
        },
        '@media only screen and (min-width: 3501px)': {
          fontSize: '40px',
        },
    },
    mainpopup: {
        background: '#fff',
        position: 'absolute',
        margin: '10px auto 0',
        border: '1px solid #24618E',
        borderRadius: '5px',
        left: '10px',
        top: '45px',
        padding: '10px',
        width: '90%'
    }
}));
//End Css Code ....

let speedLimitField = 'none';

//Start StationDetails component code ....
const StationDetails = props => {
    let history = useHistory();
    const [interactionApproch, setInteractionApproch] = React.useState("hideInteraction");
    const [midBlockApproch, setMidBlockApproch] = React.useState({ label: "hideMidBlock" });
    const [home, setHome] = React.useState(null);
    const [zoom, setZoom] = React.useState(null);
    const [lat, setLat] = React.useState(38.815709858000616);
    const [long, setLong] = React.useState(-77.09734972101597);
    const [stationLocation, setStationLocation] = React.useState('');
    const [stationType, setStationType] = React.useState(0);
    const [stationTypeName, setStationTypeName] = React.useState('Select');
    const [stationPrivacy, setStationPrivacy] = React.useState(0);
    const [displayName, setDisplayName] = React.useState(0);
    const [stationId, setStationId] = React.useState(0);
    const [status, setStatus] = React.useState('');
    const [agencyState, setAgencyState] = React.useState('');
    const [jurisdiction, setJurisdiction] = React.useState('');
    const [county, setCounty] = React.useState('');
    const [community, setCommunity] = React.useState('');
    const [speedLimit, setSpeedLimit] = React.useState('');
    const [description, setDescription] = React.useState('');
    const [seasonalFG, setSeasonalFG] = React.useState('');
    const [annualFG, setAnnualFG] = React.useState('');
    const [growthFG, setGrowthFG] = React.useState('');
    const [year, setYear] = React.useState('');
    const [NHS, setNHS] = React.useState('');
    const [PRS, setPRS] = React.useState('');
    const [fccDropdownVal, setFccDropdownVal] = React.useState('');
    const [ppDropdownVal, setPpDropdownVal] = React.useState('');
    const [prsDropdownVal, setPrsDropdownVal] = React.useState('');

    const [initialLat, setInitialLat] = React.useState(38.815709858000616);
    const [initialLong, setInitialLong] = React.useState(-77.09734972101597);
    const [initialStationLocation, setInitialStationLocation] = React.useState('');
    const [initialStationType, setInitialStationType] = React.useState(0);
    const [initialStationPrivacy, setInitialStationPrivacy] = React.useState(0);
    const [initialDisplayName, setInitialDisplayName] = React.useState(0);
    const [initialStationId, setInitialStationId] = React.useState(0);
    const [initialStatus, setInitialStatus] = React.useState('');
    const [initialAgencyState, setInitialAgencyState] = React.useState('');
    const [initialJurisdiction, setInitialJurisdiction] = React.useState('');
    const [initialCounty, setInitialCounty] = React.useState('');
    const [initialCommunity, setInitialCommunity] = React.useState('');
    const [initialSpeedLimit, setInitialSpeedLimit] = React.useState('');
    const [initialDescription, setInitialDescription] = React.useState('');
    const [initialSeasonalFG, setInitialSeasonalFG] = React.useState('');
    const [initialAnnualFG, setInitialAnnualFG] = React.useState('');
    const [initialGrowthFG, setInitialGrowthFG] = React.useState('');
    const [initialYear, setInitialYear] = React.useState('');
    const [initialNHS, setInitialNHS] = React.useState('');
    const [initialPRS, setInitialPRS] = React.useState('');
    const [initialFccDropdownVal, setInitialFccDropdownVal] = React.useState('');
    const [initialPpDropdownVal, setInitialPpDropdownVal] = React.useState('');
    const [initialPrsDropdownVal, setInitialPrsDropdownVal] = React.useState('');

    const [fccDropdown, setFccDropdown] = React.useState([]);
    const [primaryPurposeDropdown, setPrimaryPurposeDropdown] = React.useState([]);
    const [prsDropdown, setPrsDropdown] = React.useState([]);

    const [approaches, setApproaches] = React.useState([]);
    const [initialApproaches, setInitialApproaches] = React.useState([]);
    const [getErr, setErr] = React.useState({});

    const [resetForm, setResetForm] = React.useState(false);
    const [midApproachSelectOneErr, setMidApproachSelectOneErr] = React.useState(false);


    const [values, setValues] = React.useState({
        station_type: 0,
        station_type_name: '',
        station_privacy: 1,
        station_location: '',
        display_name: '',
        client_station_id: '',
        status: 'active',
        latitude: 0,
        longitude: 0,
        state_code: '',
        fips_county_code: '',
        jurisdiction: '',
        community: '',
        speed_limit: null,
        functional_classification: '',
        FK_functional_classification_code: null,
        FK_primary_purpose: null,
        description: '',
        seasonal_factor_group: '',
        annual_factor_group: '',
        growth_factor_group: '',
        year_station_established: null,
        national_highway_system: null,
        FK_posted_route_signing: null,
        posted_signed_route_number: '',
        nb_approach: '',
        sb_approach: '',
        swb_approach: '',
        seb_approach: '',
        neb_approach: '',
        nwb_approach: '',
        eb_approach: '',
        wb_approach: '',
    });

    const [midAllApproaches, setMidAllApproaches] = React.useState({
        approachOne: {},
        approachTwo: {}
    });

    const [intAllApproaches, setIntAllApproaches] = React.useState({
        approachOne: {},
        approachTwo: {},
        approachThree: {},
        approachFour: {},
        approachFive: {},
        approachSix: {},
        approachSeven: {},
        approachEight: {},
    });

    const [errPopUp, setErrPopUp] = React.useState(false);
    const [errMsg, setErrMsg] = React.useState(null);
    const [errMsgType, setErrMsgType] = React.useState('error');
    const [loader, setLoader] = React.useState(false);

    const [approachError, setApproachError] = React.useState(false);
    const [approachErrorBlank, setApproachErrorBlank] = React.useState(false);

    const mapRef = useRef();
    const classes = useStyles();
    let view = null;
    let acccessToken = null;

    const [tempMapView, setTempMapView] = React.useState(null);
    const [geocodeAcccessToken, setGeocodeAcccessToken] = React.useState(null);
    const [getEnableFlag, setEnableFlag] = React.useState();
    const [stationTypeValue, setStationTypeValue] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [getFileName, setFileName] = React.useState();
    const [myFileID, setMyFileId] = React.useState();
    const [successMsg, setSuccessMsg] = React.useState(false);
    const [stationList, setStationList] = React.useState([]);
    const [pagination, setPagnation] = React.useState({ selectedPage: 1 });
    const [totalItems, setTotalItems] = React.useState(0);
    const [getLoader, setLoaderDisable] = React.useState(false);
    const [userAccess, setUserAccess] = React.useState(true);
    // const [midApproachSelectOneErr, setMidApproachSelectOneErr] = React.useState(false);
    const [midApproachSelectTwoErr, setMidApproachSelectTwoErr] = React.useState(false);

    const [intApproachSelectOneErr, setIntApproachSelectOneErr] = React.useState(false);
    const [intApproachSelectTwoErr, setIntApproachSelectTwoErr] = React.useState(false);
    const [intApproachSelectThreeErr, setIntApproachSelectThreeErr] = React.useState(false);
    const [intApproachSelectFourErr, setIntApproachSelectFourErr] = React.useState(false);
    const [getApprochReset, setApprochReset] = React.useState([]);
    const [getFlag,setFlag]= React.useState(sessionStorage.getItem("deleteFlag"));
    //
    const [stationHasData, setStationHasData] = React.useState(false);
    let enteriesPerPage = 25;

    // basemap selection
    const [getMapLayer, setMapLayer] = React.useState(false);

    useEffect(
        () => {
            // getFFCdropdown();
            // getPrimPPdropdown();
            // getPRSdropdown();
             
            getStationTypeData();
            checkHasStationData();
            getStationDetails();
            getMapAccessToken();
        }, []
    );

    const checkHasStationData = () => {
        try {
            axios({
                method: 'post',
                headers: {
                    'payload': Cookies.get('payload'),
                    'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.stationHasData + `${sessionStorage.getItem('viewStationId')}`,
            })
                .then(async function (response) {
                    if(response.status == 200){
                        let checkStationHasData = response.data.data; 
                        setStationHasData(checkStationHasData); 
                        console.log('station has data',checkStationHasData);                       
                    }else{
                        console.error(response)
                    }                   
                })
                .catch(function (error) {
                    console.error(error);
                })
        } catch (error) {

            console.error(error);
        }
    }

    const getMapAccessToken = () => {
        try {
            axios({
                method: 'GET',
                url: API_URL + API_PATH.getArcGISToken,
                headers: {
                    'payload': Cookies.get('payload'),
                },
            })
                .then(async function (response) {
                    acccessToken = response.data.access_token;
                    setGeocodeAcccessToken(response.data.access_token);
                })
                .catch(function (error) {
                    console.error(error);
                })
        } catch (error) {

            console.error(error);
        }
    }

    const homeEvent = () => { // event to go at initial view
        home.go();
        setPointer(initialLong, initialLat)
        home.on("go", function (event) {

        })
    }
    const ZoomInEvent = () => { // event to zoom in map
        zoom.zoomIn();

    }
    const zoomOutEvent = () => { // event to zoom out map
        zoom.zoomOut();

    }
    const getFFCdropdown = () => {
        try {
            axios({
                method: 'GET',
                url: API_URL + API_PATH.getFunctionalClassificationCodes,
            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        setFccDropdown(response.data.data);
                    } else {
                        setFccDropdown([]);
                    }
                })
                .catch(function (error) {
                    setFccDropdown([]);
                })
        } catch (error) {
            setFccDropdown([]);
            console.error(error);
        }
    }

    const getPrimPPdropdown = () => {
        try {
            axios({
                method: 'GET',
                url: API_URL + API_PATH.getPrimaryPurpose,
            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        setPrimaryPurposeDropdown(response.data.data);
                    } else {
                        setPrimaryPurposeDropdown([]);
                    }
                })
                .catch(function (error) {
                    setPrimaryPurposeDropdown([]);
                })
        } catch (error) {
            setPrimaryPurposeDropdown([]);
            console.error(error);
        }
    }


    const getPRSdropdown = () => {
        try {
            axios({
                method: 'GET',
                headers: {
                    'authorization': `Bearer ${Cookies.get('jwtToken')}`,
                },
                url: API_URL + API_PATH.getPostedRouting,
            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        setPrsDropdown(response.data.data);
                    } else {
                        setPrsDropdown([]);
                    }
                })
                .catch(function (error) {
                    setPrsDropdown([]);
                })
        } catch (error) {
            setPrsDropdown([]);
            console.error(error);
        }
    }

    // This funtion is for get all station data
    const getStationTypeData = () => {
        try {
            axios({
                method: 'GET',
                url: API_URL + API_PATH.getStationType,
            })
                .then(async function (response) {
                    if (response && response.status == 200) {
                        setStationTypeValue(response.data.data);
                    }
                    else {
                        setStationTypeValue([]);
                    }
                })
                .catch(function (error) {
                    console.error(error);
                })
        } catch (error) {

            console.error(error);
        }
    }

    // // This function is for Interaction Approches start
    // const showInterractionApproches = () => {
    //     let stationType = document.getElementById('station_Type');
    //     if (stationType.value == 2) {
    //         setInteractionApproch('hideInteraction');
    //     }
    //     else {
    //         setInteractionApproch('displayInteraction');
    //     }
    // }

    // This function is for Interaction Approches start
    const showInterractionApproches = (e) => {
        setApproachError(false);
        setApproachErrorBlank(false);
        // values.station_type_name = (e.target.value == 1 ? "midblock" : "intersection") ;
        // setValues(values);
        // let filterSpace = approaches.filter(function (el,index) { return Object.values(el)[index] != ""; });
        let stationType = document.getElementById('station_Type');
        setValues({ ...values, "station_type_name": e.target.value == 1 ? "midblock" : "intersection", 'station_type': stationType.value });
        if (stationType.value == 2) {
            setInteractionApproch('displayInteraction');
            setMidBlockApproch('hideMidBlock');
            speedLimitField = 'none';
            // document.getElementById('intersection_Approaches_text_').value = '';
            document.getElementById('intersection_Approaches_text_1').value = '';
            document.getElementById('intersection_Approaches_text_2').value = '';
            document.getElementById('intersection_Approaches_text_3').value = '';
            document.getElementById('intersection_Approaches_text_4').value = '';
            document.getElementById('intersection_Approaches_select_1').value = '';
            document.getElementById('intersection_Approaches_select_2').value = '';
            document.getElementById('intersection_Approaches_select_3').value = '';
            document.getElementById('intersection_Approaches_select_4').value = '';
            setApproaches([
                { eb_approach: "" },
                { nb_approach: "" },
                { sb_approach: "" },
                { wb_approach: "" }
            ]);

        }
        else {
            setInteractionApproch('hideInteraction');
            setMidBlockApproch('displayMidBlock')
            document.getElementById('mid_Approaches_text_1').value = '';
            document.getElementById('mid_Approaches_text_2').value = '';
            document.getElementById('mid_Approaches_select_1').value = "null";
            document.getElementById('mid_Approaches_select_2').value = "null";
            setApproaches([
                { eb_approach: "" },
                { nb_approach: "" },
                { sb_approach: "" },
                { wb_approach: "" }]);


            setMidAllApproaches({ approachOne: {}, approachTwo: {} });


            speedLimitField = 'none';
        }
    }

    // This function is for Interaction Approches End
    const getStationDetails = () => { // API call to get team details
        try {
            axios({
                method: 'get',
                headers: {
                    'payload': Cookies.get('payload'),
                    'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.getStationInfoAPI + `${sessionStorage.getItem('viewStationId')}`,
            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        let data = response.data.data;
                        setValues({
                            station_type: data.station_type,
                            update_flag: data.update_flag,
                            station_type_name: data.station_type_name,
                            station_privacy: data.station_privacy,
                            station_location: data.station_location,
                            display_name: data.display_name,
                            client_station_id: data.client_station_id,
                            status: data.status,
                            latitude: data.latitude,
                            longitude: data.longitude,
                            state_code: data.state_code,
                            fips_county_code: data.fips_county_code,
                            jurisdiction: data.jurisdiction,
                            community: data.community,
                            speed_limit: data.speed_limit,
                            FK_functional_classification_code: data.FK_functional_classification_code,
                            FK_primary_purpose: data.FK_primary_purpose,
                            description: data.description,
                            seasonal_factor_group: data.seasonal_factor_group,
                            annual_factor_group: data.annual_factor_group,
                            growth_factor_group: data.growth_factor_group,
                            year_station_established: data.year_station_established,
                            national_highway_system: data.national_highway_system,
                            FK_posted_route_signing: data.FK_posted_route_signing,
                            posted_signed_route_number: data.posted_signed_route_number,

                            nb_approach: data.nb_approach,
                            sb_approach: data.sb_approach,
                            swb_approach: data.swb_approach,
                            seb_approach: data.seb_approach,
                            neb_approach: data.neb_approach,
                            nwb_approach: data.nwb_approach,
                            eb_approach: data.eb_approach,
                            wb_approach: data.wb_approach,
                        })

                        setStationType(data.station_type);
                        setEnableFlag(data.update_flag);
                        setStationTypeName(data.station_type_name);
                        setStationPrivacy(data.station_privacy);
                        setStationLocation(data.station_location);
                        setDisplayName(data.display_name);
                        setStationId(data.client_station_id);
                        setStatus(data.status);
                        setLat(data.latitude);
                        setLong(data.longitude);
                        setAgencyState(data.state_code);
                        setJurisdiction(data.jurisdiction);
                        setCounty(data.fips_county_code);
                        setCommunity(data.community);
                        setSpeedLimit(data.speed_limit);
                        setDescription(data.description);
                        setSeasonalFG(data.seasonal_factor_group);
                        setAnnualFG(data.growth_factor_group);
                        setGrowthFG(data.annual_factor_group);
                        setYear(data.year_station_established)
                        setNHS(data.national_highway_system);
                        setPRS(data.posted_signed_route_number);
                        setFccDropdownVal(data.FK_functional_classification_code);
                        setPpDropdownVal(data.FK_primary_purpose);
                        setPrsDropdownVal(data.FK_posted_route_signing);
                        // setApprochReset(
                        //     [
                        //         { eb_approach: data.eb_approach },
                        //         { nb_approach: data.nb_approach },
                        //         { sb_approach: data.sb_approach },
                        //         { wb_approach: data.wb_approach }
                        //     ]
                        // )
                        setApproaches(
                            [...approaches,
                            { eb_approach: data.eb_approach },
                            { nb_approach: data.nb_approach },
                            { sb_approach: data.sb_approach },
                            { wb_approach: data.wb_approach }
                            ].sort(function(a,b){return (Object.values(a)[0] == '')?1 : -1}));
                        setInitialLat(data.latitude);
                        setInitialLong(data.longitude);
                        setInitialStationLocation(data.station_location);
                        setInitialStationType(data.station_type);
                        setInitialStationPrivacy(data.station_privacy);
                        setInitialDisplayName(data.display_name);
                        setInitialStationId(data.client_station_id);
                        setInitialStatus(data.status);
                        setInitialAgencyState(data.state_code);
                        setInitialJurisdiction(data.jurisdiction);
                        setInitialCounty(data.fips_county_code);
                        setInitialCommunity(data.community);
                        setInitialSpeedLimit(data.speed_limit);
                        setInitialDescription(data.description);
                        setInitialSeasonalFG(data.seasonal_factor_group);
                        setInitialAnnualFG(data.growth_factor_group);
                        setInitialGrowthFG(data.annual_factor_group);
                        setInitialYear(data.year_station_established);
                        setInitialNHS(data.national_highway_system);
                        setInitialPRS(data.posted_signed_route_number);
                        setInitialFccDropdownVal(data.FK_functional_classification_code);
                        setInitialPpDropdownVal(data.FK_primary_purpose);
                        setInitialPrsDropdownVal(data.FK_posted_route_signing);
                        setInitialApproaches(
                            [
                                ...initialApproaches,
                                { eb_approach: data.eb_approach },
                                { nb_approach: data.nb_approach },
                                { sb_approach: data.sb_approach },
                                { swb_approach: data.swb_approach },
                                { seb_approach: data.seb_approach },
                                { neb_approach: data.neb_approach },
                                { nwb_approach: data.nwb_approach },
                                { wb_approach: data.wb_approach }
                            ]
                        )
                        let mapType = Cookies.get('stationDetailsMap') ? Cookies.get('stationDetailsMap') : 'streets-navigation-vector';
                       
                        loadMap(mapType, data.latitude, data.longitude);
                        if (data.station_type === 2) {
                            setIntAllApproaches([
                                { eb_approach: data.eb_approach },
                                { nb_approach: data.nb_approach },
                                { sb_approach: data.sb_approach },
                                { swb_approach: data.swb_approach },
                                { seb_approach: data.seb_approach },
                                { neb_approach: data.neb_approach },
                                { nwb_approach: data.nwb_approach },
                                { wb_approach: data.wb_approach }
                            ]);
                            setInteractionApproch('displayInteraction');
                            setMidBlockApproch('hideMidBlock');
                            speedLimitField = 'none';
                        }
                        else {
                            setMidAllApproaches([
                                { eb_approach: data.eb_approach },
                                { nb_approach: data.nb_approach },
                                { sb_approach: data.sb_approach },
                                { swb_approach: data.swb_approach },
                                { seb_approach: data.seb_approach },
                                { neb_approach: data.neb_approach },
                                { nwb_approach: data.nwb_approach },
                                { wb_approach: data.wb_approach }
                            ]);

                            setMidBlockApproch('displayMidBlock')
                            setInteractionApproch('hideInteraction');
                            speedLimitField = 'none';
                            // if (data.station_type === 1) {
                            //     speedLimitField = 'none';
                            //     setInteractionApproch('hideInteraction');
                            //     setMidBlockApproch('hideMidBlock');
                            // }
                        }

                        if(data && data.nb_approach || data.sb_approach){
                            document.getElementById('mid_Approaches_select_1').value = "NB";
                            document.getElementById('mid_Approaches_text_1').value = data.nb_approach;

                            document.getElementById('mid_Approaches_select_2').value = "SB";
                            document.getElementById('mid_Approaches_text_2').value = data.sb_approach;
                        }

                        if(data && data.eb_approach || data.wb_approach){
                            document.getElementById('mid_Approaches_select_1').value = "EB";
                            document.getElementById('mid_Approaches_text_1').value = data.eb_approach;

                            document.getElementById('mid_Approaches_select_2').value = "WB";
                            document.getElementById('mid_Approaches_text_2').value = data.wb_approach;
                        }
                    } else {

                    };
                })
                .catch(async function (error) {
                    if (error.response) {
                        if (error.response.status && error.response.status == '401') {
                            if (Cookies.get('email')) {
                                clearCookie('email');
                                clearCookie('payload');
                                clearCookie('idToken');
                                clearCookie('organization');
                                clearCookie('atexpiry');
                            }
                            history.push('/');
                        }
                    }
                })
        } catch (error) {
            console.error(error);
        }
    }

    const clearStationForm = () => {
        document.getElementById('station_Type').value = initialStationType;
        setStationType(initialStationType);
        setStationPrivacy(initialStationPrivacy);
        setStationLocation(initialStationLocation);
        setDisplayName(initialDisplayName);
        setStationId(initialStationId);
        setStatus(initialStatus);
        setLat(initialLat);
        setLong(initialLong);
        setAgencyState(initialAgencyState);
        // setJurisdiction(initialJurisdiction);
        setCounty(initialCounty);
        // setCommunity(initialCommunity);
        // setSpeedLimit(initialSpeedLimit);
        // setDescription(initialDescription);
        // setSeasonalFG(initialSeasonalFG);
        // setAnnualFG(initialAnnualFG);
        // setGrowthFG(initialGrowthFG);
        // setYear(initialYear)
        // setNHS(initialNHS);
        // setPRS(initialPRS);
        // setFccDropdownVal(initialFccDropdownVal);
        // setPpDropdownVal(initialPpDropdownVal);
        // setPrsDropdownVal(initialPrsDropdownVal);
        if (initialStationType === 2) {

            setIntAllApproaches(initialApproaches);
            setInteractionApproch('displayInteraction');
            setMidBlockApproch('hideMidBlock');
            speedLimitField = 'none';
        }
        else {

            setMidAllApproaches(initialApproaches);
            setMidBlockApproch('displayMidBlock')
            setInteractionApproch('hideInteraction');
            speedLimitField = 'none';
        }
        let initialData = {
            ...values,
            station_type: initialStationType,
            station_privacy: initialStationPrivacy,
            station_location: initialStationLocation,
            display_name: initialDisplayName,
            client_station_id: initialStationId,
            status: initialStatus,
            latitude: initialLat,
            longitude: initialLong,
            state_code: initialAgencyState,
            fips_county_code: initialCounty,
            jurisdiction: initialJurisdiction,
            community: initialCommunity,
            speed_limit: initialSpeedLimit,
            FK_functional_classification_code: initialFccDropdownVal,
            FK_primary_purpose: initialPpDropdownVal,
            description: initialDescription,
            seasonal_factor_group: initialSeasonalFG,
            annual_factor_group: initialAnnualFG,
            growth_factor_group: initialGrowthFG,
            year_station_established: initialYear,
            national_highway_system: initialNHS,
            FK_posted_route_signing: initialPrsDropdownVal,
            posted_signed_route_number: initialPRS,
            station_type_name: initialStationType == 1 ? "midblock" : "intersection",
            initialApproaches,
            // getApprochReset
        }
        setValues({ ...values, ...initialData });
        // setMidAllApproaches();
        setResetForm(true);
        setPointer(initialLong, initialLat)
    }

    const loadMap = (basemap = 'streets-navigation-vector', lat, lng) => {
        // lazy load the required ArcGIS API for JavaScript modules and CSS
        loadModules(['esri/Map', 'esri/views/MapView', "esri/widgets/Home", "esri/widgets/Zoom", "esri/layers/FeatureLayer", "esri/Viewpoint", "esri/geometry/Point", "esri/Graphic", "esri/layers/GraphicsLayer", "esri/symbols/PictureMarkerSymbol", "esri/widgets/Search",
        "esri/widgets/BasemapToggle",
        "esri/widgets/BasemapGallery"], { css: true })
            .then(([ArcGISMap, MapView, Home, Zoom, FeatureLayer, Viewpoint, Point, Graphic, GraphicsLayer, PictureMarkerSymbol, Search,
                BasemapToggle, BasemapGallery]) => {
                const map = new ArcGISMap({
                    basemap,
                    slider: false
                });

                view = new MapView({
                    container: mapRef.current,
                    map: map,
                    isPan: true,
                    // center: [-106.61, 35.1107],
                    zoom: 20,
                    ui: {
                        components: ['home', 'locate'] // specify only the components you want
                    },
                });
                let mapTypePrev = Cookies.get('stationDetailsMap') && Cookies.get('stationDetailsMap') === 'hybrid' ? 'streets-navigation-vector' : 'hybrid';
                var basemapToggle = new BasemapToggle({
                    view: view,  // The view that provides access to the map's "streets-vector" basemap
                    nextBasemap: mapTypePrev  // Allows for toggling to the "hybrid" basemap
                  });
            
                  view.ui.add(basemapToggle,"bottom-right");
                 
                setTempMapView(view)
                let featureLayer = new FeatureLayer({
                    url: sessionStorage.getItem('mapURL')
                });
                map.add(featureLayer);
                featureLayer.when(function () { // adds feature layer to map view
                    let vp = new Viewpoint({
                        targetGeometry: featureLayer.fullExtent
                    });
                    homeButton.viewpoint = vp;
                    view.extent = featureLayer.fullExtent;
                    let point = new Point(lng, lat);
                    let pointSymbol = {
                        type: "simple-marker",
                        style: "circle",
                        color: "#00b15e",
                        size: 20,
                        outline: {
                            color: "#3676bc",
                            width: 0.5
                        }
                    }
                    let pointGraphic = new Graphic(point, pointSymbol);
                    view.graphics.add(pointGraphic);
                    view.goTo(pointGraphic).then(function () {
                        view.zoom = view.zoom + 5;
                    });
                });
                var search = new Search({
                    view: view
                });

                let homeButton = new Home({
                    view: view,
                });
                let zoom = new Zoom({
                    view: view,
                });
                setHome(homeButton)
                setZoom(zoom)

                let path = require('../../assets/images/mapPoint.svg')

                let draggingGraphic;
                let tempGraphic;
                let points;

                view.on("drag", function (evt) {
                    if (evt.action === 'start') {
                        view.hitTest(evt).then(resp => {
                            console.log("resp.results[0].graphic",resp.results[0].graphic.geometry.type)
                            if (resp.results[0].graphic && resp.results[0].graphic.geometry.type === 'point') {                                
                                evt.stopPropagation();
                                // if the hitTest returns a point graphic, set dragginGraphic
                                draggingGraphic = resp.results[0].graphic;
                            }
                        });
                    } else if (evt.action === 'update') {
                        // on drag update events, only continue if a draggingGraphic is set
                        if (draggingGraphic) {
                            evt.stopPropagation();
                            // if there is a tempGraphic, remove it
                            if (tempGraphic) {
                                view.graphics.remove(tempGraphic);
                            } else {
                                // if there is no tempGraphic, this is the first update event, so remove original graphic
                                view.graphics.remove(draggingGraphic);
                            }
                            // create new temp graphic and add it
                            tempGraphic = draggingGraphic.clone();
                            tempGraphic.geometry = view.toMap(evt);
                            view.graphics.add(tempGraphic);
                        }

                    } else if (evt.action === 'end') {
                        view.hitTest(evt).then(resp => {
                            if (resp.results[0].graphic && resp.results[0].graphic.geometry.type === 'point') {
                                points = resp.results[0].mapPoint;

                                if (draggingGraphic) {
                                    let instance = axios.create();
                                    delete instance.defaults.headers.common['X-CSRF-TOKEN'];
                                    try {
                                        instance({
                                            method: 'GET',
                                            url: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode?f=pjson&featureTypes=StreetInt, StreetAddress, StreetName &location=' + `${resp.results[0].mapPoint.longitude}` + ',' + `${resp.results[0].mapPoint.latitude}` + '&token=' + acccessToken

                                        })
                                            .then(async function (response) {
                                               
                                                if(response.data.error){
                                                
                                                    setLat("");
                                                    setLong("");
                                                    setStationLocation("");
                                                    
                                                    setAgencyState("");
                                                   // setAgencyState(stateCode[2]);
                                                    setCounty("");

                                                }else{
                                                    var address = response.data.address;
                                                    setLat(points.latitude);
                                                    setLong(points.longitude);
                                                    setStationLocation(address.Match_addr);
                                                    let stateCode = address.LongLabel.split(',');
                                                    let code_station_position=2;
                                                    if(address.Postal!=""){
                                                        code_station_position=3;
                                                        if(address.Postal==address.PlaceName){
                                                            code_station_position=2;
                                                        }
                                                    }
                                                    setAgencyState(stateCode[stateCode.length-code_station_position]);
                                                   // setAgencyState(stateCode[2]);
                                                    setCounty(address.Subregion);
                                                    

                                                }
                                               
                                            })
                                            .catch(function (error) {
                                                console.error(error);
                                            })
                                    } catch (error) {
                                        console.error(error);
                                    }

                                    if (tempGraphic) view.graphics.remove(tempGraphic);
                                    // create new graphic based on original dragging graphic
                                    let newGraphic = draggingGraphic.clone();
                                    newGraphic.geometry = tempGraphic.geometry.clone();

                                    // add replacement graphic
                                    view.graphics.add(newGraphic);

                                    // reset vars
                                    draggingGraphic = null;
                                    tempGraphic = null;
                                }                              
                            }
                        });
                        // on drag end, continue only if there is a draggingGraphic

                    }
                })

            });
    }
    const ShowErrPopUP = () => {
        setErrPopUp(false);
    };

    const handleChange = name => async event => {
        setErrMsg(null);
        let value = event.target.value;
        let longitude = long;
        let latitude = lat;
        let location = stationLocation;
        if (name == 'station_Privacy') {
            setStationPrivacy(event.target.value)
        } else if (name == 'display_name') {
            setDisplayName(event.target.value);
        } else if (name == 'client_station_id') {
            setStationId(event.target.value);
        } else if (name == 'status_check') {
            setStatus(event.target.value)
        } else if (name == 'jurisdiction') {
            setJurisdiction(event.target.value)
        } else if (name == 'community') {
            setCommunity(event.target.value)
        } else if (name == 'speed_limit') {
            setSpeedLimit(event.target.value)
        } else if (name == 'FK_functional_classification_code') {
            setFccDropdownVal(event.target.value)
        } else if (name == 'FK_primary_purpose') {
            setPrsDropdownVal(event.target.value)
        } else if (name == 'description') {
            setDescription(event.target.value)
        } else if (name == 'seasonal_factor_group') {
            setSeasonalFG(event.target.value)
        } else if (name == 'annual_factor_group') {
            setAnnualFG(event.target.value)
        } else if (name == 'growth_factor_group') {
            setGrowthFG(event.target.value)
        } else if (name == 'year_station_established') {
            setYear(event.target.value)
        } else if (name == 'national_highway_system') {
            setNHS(event.target.value)
        } else if (name == 'FK_posted_route_signing') {
            setPrsDropdownVal(event.target.value)
        } else if (name == 'Posted_Signed_Route_Number') {
            setPRS(event.target.value)
        }
        if (name == 'station_privacy' ||
            // name == 'speed_limit' ||
            name == 'FK_functional_classification_code' ||
            name == 'FK_posted_route_signing' || name == 'year_station_established') {
            value = event.target.value ? parseInt(event.target.value) : null;
        } else if (name == 'FK_primary_purpose') {
            value = event.target.value == 'Select' ? null : event.target.value;
        } else if (name == 'national_highway_system') {
            if (event.target.value == 'true') {
                value = true;
            } else if (event.target.value == 'false') {
                value = false;
            } else {
                value = null;
            }
        } else if (name == 'latitude') {
            setLat(event.target.value);
            latitude = event.target.value;
            await setPointer(longitude, latitude);

        } else if (name == 'longitude') {
            setLong(event.target.value);
            longitude = event.target.value;
            await setPointer(longitude, latitude);

        } else if (name == 'station_location') {
            setStationLocation(event.target.value);
            location = event.target.value;
        } else if (name == 'speed_limit') {
            value = event.target.value ? event.target.value : null;
        } else {
            value = event.target.value;
        }
        setValues({ ...values, [name]: value });

    }


    const setPointer = (longitude, latitude) => { //set pointer on form inputs change
        loadModules(["esri/geometry/Point", "esri/Graphic", "esri/symbols/PictureMarkerSymbol", "esri/geometry/Extent"], { css: true })
            .then(([Point, Graphic, PictureMarkerSymbol, Extent]) => {
                let path = require('../../assets/images/mapPoint.svg');
                tempMapView.graphics.removeAll();
                var point = new Point(parseFloat(longitude), parseFloat(latitude));
                let pointSymbol = {
                    type: "simple-marker",
                    style: "circle",
                    color: "#00b15e",
                    size: 20,
                    outline: {
                        color: "#3676bc",
                        width: 0.5
                    }
                }
                var pointGraphic = new Graphic(point, pointSymbol);
                let instance = axios.create();
                delete instance.defaults.headers.common['X-CSRF-TOKEN'];
                try {
                    instance({
                        method: 'GET',
                        url: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode?f=pjson&featureTypes=StreetInt, StreetAddress, StreetName &location=' + `${longitude}` + ',' + `${latitude}` + '&token=' + geocodeAcccessToken

                    })

                    
                        .then(async function (response) {
                            
                            if(response.data.error){
                                setLat("");
                                setLong("");
                                setStationLocation("");
                                
                                setAgencyState("");
                            // setAgencyState(stateCode[2]);
                                setCounty("");
                                

                            }else{
                                var address = response.data.address;
                                setLat(latitude);
                                setLong(longitude);
                                setStationLocation(address.Match_addr);
                                let stateCode = address.LongLabel.split(',');
                                let code_station_position=2;
                                if(address.Postal!=""){
                                    code_station_position=3;
                                    if(address.Postal==address.PlaceName){
                                        code_station_position=2;
                                    }
                                }
                                setAgencyState(stateCode[stateCode.length-code_station_position]);
                            // setAgencyState(stateCode[2]);
                                setCounty(address.Subregion);
                                tempMapView.extent = new Extent({
                                    xmin: response.data.location.x,
                                    ymin: response.data.location.y,
                                    spatialReference: {
                                        wkid: response.data.location.spatialReference.wkid
                                    }
                                });
                                tempMapView.goTo(point);
                                tempMapView.zoom = 13;
                                

                            }
                            
                        })
                        .catch(function (error) {
                            console.error(error);
                        })
                } catch (error) {
                    console.error(error);
                }
                tempMapView.graphics.add(pointGraphic);
            })
    }


    const selectApproach = (e) => { //This function validates the approach dropdowns        
        setApproachError(false);
        setApproachErrorBlank(false);
        setErrMsg('');
        setMidApproachSelectOneErr(false);
        setMidApproachSelectTwoErr(false);
        setIntApproachSelectOneErr(false);
        setIntApproachSelectTwoErr(false);
        setIntApproachSelectThreeErr(false);
        setIntApproachSelectFourErr(false);

        let getSelectElement = e.target.id;
        // console.log("getSelectElement", getSelectElement, (document.getElementById('mid_Approaches_select_2').value), document.getElementById('mid_Approaches_select_2').length);
        
        if (getSelectElement == 'intersection_Approaches_select_2') {
           
            if (e.target.value !== '' && (document.getElementById('intersection_Approaches_select_1').value == e.target.value || document.getElementById('intersection_Approaches_select_3').value == e.target.value || document.getElementById('intersection_Approaches_select_4').value == e.target.value)) {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Stations cannot have multiple entries for the same approach direction.');
                setIntApproachSelectTwoErr(true);
            } //else {
                if (e.target.value == 'EB') {
                    setIntAllApproaches({ ...intAllApproaches, approachTwo: { eb_approach: document.getElementById('intersection_Approaches_text_2').value } });
                } else if (e.target.value == 'NB') {
                    setIntAllApproaches({ ...intAllApproaches, approachTwo: { nb_approach: document.getElementById('intersection_Approaches_text_2').value } });
                } else if (e.target.value == 'SB') {
                    setIntAllApproaches({ ...intAllApproaches, approachTwo: { sb_approach: document.getElementById('intersection_Approaches_text_2').value } });
                } else if (e.target.value == 'WB') {
                    setIntAllApproaches({ ...intAllApproaches, approachTwo: { wb_approach: document.getElementById('intersection_Approaches_text_2').value } });
                } else {
                    setIntAllApproaches({ ...intAllApproaches, approachTwo: {nb_approach:''} });
                    document.getElementById('intersection_Approaches_text_2').value = '';
                }
           // }
        } else if (getSelectElement == 'intersection_Approaches_select_1') {
            if (e.target.value !== '' && (document.getElementById('intersection_Approaches_select_2').value == e.target.value || document.getElementById('intersection_Approaches_select_3').value == e.target.value || document.getElementById('intersection_Approaches_select_4').value == e.target.value)) {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Stations cannot have multiple entries for the same approach direction.');
                setIntApproachSelectOneErr(true);                
            } //else {
                if (e.target.value == 'EB') {
                    setIntAllApproaches({ ...intAllApproaches, approachOne: { eb_approach: document.getElementById('intersection_Approaches_text_1').value } });
                } else if (e.target.value == 'NB') {
                    setIntAllApproaches({ ...intAllApproaches, approachOne: { nb_approach: document.getElementById('intersection_Approaches_text_1').value } });
                } else if (e.target.value == 'SB') {
                    setIntAllApproaches({ ...intAllApproaches, approachOne: { sb_approach: document.getElementById('intersection_Approaches_text_1').value } });
                } else if (e.target.value == 'WB') {
                    setIntAllApproaches({ ...intAllApproaches, approachOne: { wb_approach: document.getElementById('intersection_Approaches_text_1').value } });
                } else {
                    setIntAllApproaches({ ...intAllApproaches, approachOne: {eb_approach:''} });
                    document.getElementById('intersection_Approaches_text_1').value = '';                    
                }                
           // }
        } else if (getSelectElement == 'intersection_Approaches_select_3') {
            if (e.target.value !== '' && (document.getElementById('intersection_Approaches_select_2').value == e.target.value || document.getElementById('intersection_Approaches_select_1').value == e.target.value || document.getElementById('intersection_Approaches_select_4').value == e.target.value)) {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Stations cannot have multiple entries for the same approach direction.');
                setIntApproachSelectThreeErr(true);
            } //else {

                if (e.target.value == 'EB') {
                    setIntAllApproaches({ ...intAllApproaches, approachThree: { eb_approach: document.getElementById('intersection_Approaches_text_3').value } });
                } else if (e.target.value == 'NB') {
                    setIntAllApproaches({ ...intAllApproaches, approachThree: { nb_approach: document.getElementById('intersection_Approaches_text_3').value } });
                } else if (e.target.value == 'SB') {
                    setIntAllApproaches({ ...intAllApproaches, approachThree: { sb_approach: document.getElementById('intersection_Approaches_text_3').value } });
                } else if (e.target.value == 'WB') {
                    setIntAllApproaches({ ...intAllApproaches, approachThree: { wb_approach: document.getElementById('intersection_Approaches_text_3').value } });
                } else {
                    setIntAllApproaches({ ...intAllApproaches, approachThree: {sb_approach:''} });
                    document.getElementById('intersection_Approaches_text_3').value = '';
                }
           // }
        } else if (getSelectElement == 'intersection_Approaches_select_4') {
            if (e.target.value !== '' && (document.getElementById('intersection_Approaches_select_2').value == e.target.value || document.getElementById('intersection_Approaches_select_3').value == e.target.value || document.getElementById('intersection_Approaches_select_1').value == e.target.value)) {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Stations cannot have multiple entries for the same approach direction.');
                setIntApproachSelectFourErr(true);
            }// else {
                if (e.target.value == 'EB') {
                    setIntAllApproaches({ ...intAllApproaches, approachFour: { eb_approach: document.getElementById('intersection_Approaches_text_4').value } });
                } else if (e.target.value == 'NB') {
                    setIntAllApproaches({ ...intAllApproaches, approachFour: { nb_approach: document.getElementById('intersection_Approaches_text_4').value } });
                } else if (e.target.value == 'SB') {
                    setIntAllApproaches({ ...intAllApproaches, approachFour: { sb_approach: document.getElementById('intersection_Approaches_text_4').value } });
                } else if (e.target.value == 'WB') {
                    setIntAllApproaches({ ...intAllApproaches, approachFour: { wb_approach: document.getElementById('intersection_Approaches_text_4').value } });
                } else {
                    setIntAllApproaches({ ...intAllApproaches, approachFour: {wb_approach:''} });
                    document.getElementById('intersection_Approaches_text_4').value = '';
                }

                
            //}
        } else if (getSelectElement == 'mid_Approaches_select_1' && (document.getElementById('mid_Approaches_select_2').value !== '')) {
           
            // document.getElementById('mid_Approaches_text_2').value = '';
            //document.getElementById('mid_Approaches_text_1').value = '';
            //setMidAllApproaches({ ...midAllApproaches, ...midAllApproaches.approachTwo = {} });
            
            setMidAllApproaches({...midAllApproaches,
                0:{ eb_approach: "" },
                1:{ nb_approach: "" },
                2:{ sb_approach: "" },
                3:{ swb_approach: "" },
                4:{ seb_approach: "" },
                5:{ neb_approach: "" },
                6:{ nwb_approach: "" },
                7:{ wb_approach: "" }
            });
            let changeSelect = document.getElementById('mid_Approaches_select_2');
            //
           
          setValues({...values,"eb_approach":"","wb_approach":"","nb_approach":"","sb_approach":""})
            if (e.target.value === 'EB') {
                changeSelect.value="WB";
                setValues({...values,
                    "nb_approach":"","sb_approach":"",
                    "eb_approach":document.getElementById('mid_Approaches_text_1').value,
                    "wb_approach":document.getElementById('mid_Approaches_text_2').value})
                    
                setMidAllApproaches({ 
                    approachOne: { eb_approach: document.getElementById('mid_Approaches_text_1').value },
                    approachTwo: { wb_approach: document.getElementById('mid_Approaches_text_2').value } });
                

                
            } else if (e.target.value == 'WB') {
                changeSelect.value="EB";
                setValues({...values,
                    "nb_approach":"","sb_approach":"",
                    "wb_approach":document.getElementById('mid_Approaches_text_1').value,
                    "eb_approach":document.getElementById('mid_Approaches_text_2').value})
                
                setMidAllApproaches({ 
                    approachOne: { wb_approach: document.getElementById('mid_Approaches_text_1').value },
                    approachTwo: { eb_approach: document.getElementById('mid_Approaches_text_2').value } });
                
               
            } else if (e.target.value == 'NB') {
                changeSelect.value="SB";
                setValues({...values,
                    "eb_approach":"","wb_approach":"",
                    "nb_approach":document.getElementById('mid_Approaches_text_1').value,
                    "sb_approach":document.getElementById('mid_Approaches_text_2').value})
                setMidAllApproaches({  approachOne: { nb_approach: document.getElementById('mid_Approaches_text_1').value },
                approachTwo: { sb_approach: document.getElementById('mid_Approaches_text_2').value } });
                
                
            } else if (e.target.value == 'SB') {
                changeSelect.value="NB";
                setValues({...values,
                    "eb_approach":"","wb_approach":"",
                    "sb_approach":document.getElementById('mid_Approaches_text_1').value,
                    "nb_approach":document.getElementById('mid_Approaches_text_2').value})

                setMidAllApproaches({ 
                    approachOne: { sb_approach: document.getElementById('mid_Approaches_text_1').value },
                    approachTwo: { nb_approach:document.getElementById('mid_Approaches_text_2').value } });
                
                
            } 
        } else if (getSelectElement == 'mid_Approaches_select_2' && (document.getElementById('mid_Approaches_select_1').value !== '')) {
            
            //document.getElementById('mid_Approaches_text_1').value = '';
            setMidAllApproaches({
                0:{ eb_approach: "" },
                1:{ nb_approach: "" },
                2:{ sb_approach: "" },
                3:{ swb_approach: "" },
                4:{ seb_approach: "" },
                5:{ neb_approach: "" },
                6:{ nwb_approach: "" },
                7:{ wb_approach: "" }
            });
            
            let changeSelect = document.getElementById('mid_Approaches_select_1');
            setMidAllApproaches({ approachOne: {}, approachTwo: {} });
            

            if (e.target.value == 'EB') {
                changeSelect.value="WB";
                setValues({...values,
                    "nb_approach":"","sb_approach":"",
                    "eb_approach":document.getElementById('mid_Approaches_text_1').value,
                    "wb_approach":document.getElementById('mid_Approaches_text_2').value})
                    
                setMidAllApproaches({  
                                        approachOne: { eb_approach: document.getElementById('mid_Approaches_text_2').value },
                                        approachTwo: { wb_approach: document.getElementById('mid_Approaches_text_1').value } });
                

            console.log(values);   
            } else if (e.target.value == 'WB') {
                changeSelect.value="EB";
                setValues({...values,
                    "nb_approach":"","sb_approach":"",
                    "wb_approach":document.getElementById('mid_Approaches_text_1').value,
                    "eb_approach":document.getElementById('mid_Approaches_text_2').value})
                    
                setMidAllApproaches({  
                    approachOne: { wb_approach: document.getElementById('mid_Approaches_text_2').value },
                    approachTwo: { eb_approach: document.getElementById('mid_Approaches_text_1').value } 
                 });
                
                
            } else if (e.target.value == 'NB') {
                changeSelect.value="SB";
                setValues({...values,
                    "eb_approach":"","wb_approach":"",
                    "nb_approach":document.getElementById('mid_Approaches_text_1').value,
                    "sb_approach":document.getElementById('mid_Approaches_text_2').value})
                    
                setMidAllApproaches({ 
                    approachOne: { nb_approach: document.getElementById('mid_Approaches_text_2').value },
                    approachTwo: { sb_approach: document.getElementById('mid_Approaches_text_1').value } });
                
            } else if (e.target.value == 'SB') {
                changeSelect.value="NB";
                setValues({...values,
                    "eb_approach":"","wb_approach":"",
                    "sb_approach":document.getElementById('mid_Approaches_text_1').value,
                    "nb_approach":document.getElementById('mid_Approaches_text_2').value})
                    
                setMidAllApproaches({ 
                    approachOne: { sb_approach: document.getElementById('mid_Approaches_text_2').value },
                    approachTwo: { nb_approach: document.getElementById('mid_Approaches_text_1').value }
                 });
                
            } else if (e.target.value == '') {                             
                /*document.getElementById('mid_Approaches_text_2').value = '';                
                setMidAllApproaches({ ...midAllApproaches, approachTwo: {} });                
                let tmpValue = changeSelect.value;
                changeSelect.innerHTML = '';
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'EB';
                opt2.innerHTML = 'EB';
                changeSelect.appendChild(opt2);
                let opt3 = document.createElement('option');
                opt3.value = 'NB';
                opt3.innerHTML = 'NB';
                changeSelect.appendChild(opt3);
                let opt4 = document.createElement('option');
                opt4.value = 'SB';
                opt4.innerHTML = 'SB';
                changeSelect.appendChild(opt4);
                let opt5 = document.createElement('option');
                opt5.value = 'WB';
                opt5.innerHTML = 'WB';
                changeSelect.appendChild(opt5);
                changeSelect.value = tmpValue*/
            } else if (e.target.value == "null") {                
                /*document.getElementById('mid_Approaches_text_2').value = '';
                setMidAllApproaches({ ...midAllApproaches, approachTwo: {} });
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'EB';
                opt2.innerHTML = 'EB';
                changeSelect.appendChild(opt2);
                let opt3 = document.createElement('option');
                opt3.value = 'NB';
                opt3.innerHTML = 'NB';
                changeSelect.appendChild(opt3);
                let opt4 = document.createElement('option');
                opt4.value = 'SB';
                opt4.innerHTML = 'SB';
                changeSelect.appendChild(opt4);
                let opt5 = document.createElement('option');
                opt5.value = 'WB';
                opt5.innerHTML = 'WB';
                changeSelect.appendChild(opt5);*/
            }
        }

    }


    const approachText = (e) => {
        setErr({});
        setApproachError(false);
        let getTextElement = e.target.id;
        if (getTextElement == 'intersection_Approaches_text_1') {
            if (document.getElementById('intersection_Approaches_select_1').value == 'EB') {
                setIntAllApproaches({ ...intAllApproaches, approachOne: { eb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_1').value == 'NB') {
                setIntAllApproaches({ ...intAllApproaches, approachOne: { nb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_1').value == 'SB') {
                setIntAllApproaches({ ...intAllApproaches, approachOne: { sb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_1').value == 'WB') {
                setIntAllApproaches({ ...intAllApproaches, approachOne: { wb_approach: e.target.value.trim() } });
            }
        } else if (getTextElement == 'intersection_Approaches_text_2') {
            if (document.getElementById('intersection_Approaches_select_2').value == 'EB') {
                setIntAllApproaches({ ...intAllApproaches, approachTwo: { eb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_2').value == 'NB') {
                setIntAllApproaches({ ...intAllApproaches, approachTwo: { nb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_2').value == 'SB') {
                setIntAllApproaches({ ...intAllApproaches, approachTwo: { sb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_2').value == 'WB') {
                setIntAllApproaches({ ...intAllApproaches, approachTwo: { wb_approach: e.target.value.trim() } });
            }
        } else if (getTextElement == 'intersection_Approaches_text_3') {
            if (document.getElementById('intersection_Approaches_select_3').value == 'EB') {
                setIntAllApproaches({ ...intAllApproaches, approachThree: { eb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_3').value == 'NB') {
                setIntAllApproaches({ ...intAllApproaches, approachThree: { nb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_3').value == 'SB') {
                setIntAllApproaches({ ...intAllApproaches, approachThree: { sb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_3').value == 'WB') {
                setIntAllApproaches({ ...intAllApproaches, approachThree: { wb_approach: e.target.value.trim() } });
            }
        } else if (getTextElement == 'intersection_Approaches_text_4') {
            if (document.getElementById('intersection_Approaches_select_4').value == 'EB') {
                setIntAllApproaches({ ...intAllApproaches, approachFour: { eb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_4').value == 'NB') {
                setIntAllApproaches({ ...intAllApproaches, approachFour: { nb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_4').value == 'SB') {
                setIntAllApproaches({ ...intAllApproaches, approachFour: { sb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_4').value == 'WB') {
                setIntAllApproaches({ ...intAllApproaches, approachFour: { wb_approach: e.target.value.trim() } });
            }
        } else if (getTextElement == 'mid_Approaches_text_2') {
            if (document.getElementById('mid_Approaches_select_2').value == 'EB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { eb_approach: e.target.value.trim() } });
            } else if (document.getElementById('mid_Approaches_select_2').value == 'NB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { nb_approach: e.target.value.trim() } });
            } else if (document.getElementById('mid_Approaches_select_2').value == 'SB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { sb_approach: e.target.value.trim() } });
            } else if (document.getElementById('mid_Approaches_select_2').value == 'WB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { wb_approach: e.target.value.trim() } });
            }
        } else if (getTextElement == 'mid_Approaches_text_1') {
            if (document.getElementById('mid_Approaches_select_1').value == 'EB') {
                setMidAllApproaches({ ...midAllApproaches, approachOne: { eb_approach: e.target.value.trim() } });
            } else if (document.getElementById('mid_Approaches_select_1').value == 'NB') {
                setMidAllApproaches({ ...midAllApproaches, approachOne: { nb_approach: e.target.value.trim() } });
            } else if (document.getElementById('mid_Approaches_select_1').value == 'SB') {
                setMidAllApproaches({ ...midAllApproaches, approachOne: { sb_approach: e.target.value.trim() } });
            } else if (document.getElementById('mid_Approaches_select_1').value == 'WB') {
                setMidAllApproaches({ ...midAllApproaches, approachOne: { wb_approach: e.target.value.trim() } });
            }
        }
    }

    const validateForm = async e => {
        e.preventDefault();
        //validate if    
        try {
            axios({
                method: 'post',
            
                headers: {
                    'payload': Cookies.get('payload'),
                    'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.stationHasData + `${sessionStorage.getItem('viewStationId')}`,

            })
            .then(async function (response) {
                if (response.status && response.status == '200') {
                    
                    //enableFlag true  means this station is editable
                    //
                    let hasData=response.data.data;
                    if(getEnableFlag  && hasData){
                        setErrMsgType('error')
                        setErrMsg("Unable to edit a station that contains data");
                        setErrPopUp(true)
                        setLoader(false);
                    }else{
                        setErrMsg(null);
                        if (values.station_type == 0 &&
                            values.station_location == '' &&
                            values.client_station_id == '' &&
                            values.latitude == '' &&
                            values.longitude == '') {
                            setErrMsg('All mandatory fields are required');
                            setErrPopUp(true);
                        } else if (values.station_type == 0) {
                            setErrMsg('Station type required');
                            setErrPopUp(true);
                        } else if (stationLocation == undefined || stationLocation == '') {
                            setErrMsg('Location required');
                            setErrPopUp(true);
                        } else if (values.client_station_id == '') {
                            setErrMsg('Station ID required.');
                            setErrPopUp(true);
                        } else if (values.client_station_id.length > 20) {
                            setErrMsg('Station ID can be at most 20 characters.');
                            setErrPopUp(true);
                        } else if (values.latitude == '' || isNaN(values.latitude)) {
                            setErrMsg('Latitude required.');
                            setErrPopUp(true);
                        } else if (values.longitude == '' || isNaN(values.longitude)) {
                            setErrMsg('Longitude required.');
                            setErrPopUp(true);
                        } else if (values.speed_limit !== null && isNaN(values.speed_limit)) {
                            setErrMsg('Speed Limit Must Be Integer.');
                            setErrPopUp(true);
                        }
                        else {
                            let flagUpdateStation=true;
                            let newData;
                            if (resetForm == false) { //reseting approaches values
                                newData = { ...values, station_location: stationLocation, latitude: lat, longitude: long, state_code: agencyState, fips_county_code: county };
                            
                                if (newData.station_type == 2) {
                                    let keys = Object.keys(intAllApproaches);
                                    // let keys = Object.keys(initialApproaches);

                                    for (var i = 0; i < keys.length; i++) {
                                        var key = (keys[i]);
                                        newData = { ...newData, ...intAllApproaches[key] }
                                    }
                                        //validate if aproach has values duplicates
                                    var aproach1=document.getElementById('intersection_Approaches_select_1').value;
                                    var aproach2=document.getElementById('intersection_Approaches_select_2').value;
                                    var aproach3=document.getElementById('intersection_Approaches_select_3').value;
                                    var aproach4=document.getElementById('intersection_Approaches_select_4').value;                                    
                                    
                                    if(hasDuplicated([aproach1,aproach2,aproach3,aproach4].filter(aprc => aprc !=''))){
                                        setApproachError(true);
                                        flagUpdateStation=false;
                                        setErrMsg('Stations cannot have multiple entries for the same approach direction.');
                                    }
                                } else if (newData.station_type == 1) {                                    
                                    let keys = Object.keys(midAllApproaches);
                                    for (var i = 0; i < keys.length; i++) {
                                        var key = (keys[i]);
                                    
                                        newData = { ...newData, ...midAllApproaches[key] }

                                    }
                                        //validate if aproach has values duplicates
                                    var aproach1=document.getElementById('mid_Approaches_select_1').value;
                                    var aproach2=document.getElementById('mid_Approaches_select_2').value;
                            
                                    if(hasDuplicated([aproach1,aproach2])){
                                        setApproachError(true);
                                        flagUpdateStation=false;
                                    }
                                    
                                }
                            } else {
                                newData = { ...values, station_location: stationLocation, latitude: lat, longitude: long, state_code: agencyState, fips_county_code: county };
                                
                            }
                            if (validateApproches(newData)) {                                
                                setErrMsg('Station approaches with assigned directions cannot be blank.');
                                setErrPopUp(true);
                                setErr(newData);
                                setApproachErrorBlank(true);
                                setErrMsgType('error');
                                flagUpdateStation=false;                                
                            }

                            if (validateApprochesOneAdded(newData)) {                                
                                setErrMsg('Please fill in at least one approach.');
                                setErrPopUp(true);
                                setErr(newData);
                                setApproachErrorBlank(true);
                                setErrMsgType('error');
                                flagUpdateStation=false;                                
                            } 

                            if (flagUpdateStation){
                                updateStation(newData);
                            }

                        }
                    }

                }
            })
            .catch(function (error) {
                if (error.response) {
                    setErrMsgType('error')
                    setErrMsg(error.response.data.message);
                    setErrPopUp(true)
                    setLoader(false);
                } else {
                    setErrMsgType('error')
                    setErrMsg('Something went wrong.');
                    setErrPopUp(true)
                    setLoader(false);
                }
            })
        } catch (error) {
            setLoader(false);
        }
    }
    function hasDuplicated(arr){
        return arr.some(function(v,i) { return arr.indexOf(v,i+1)>-1 })

    }

    //This method is use for validate the approches  ... start

    function validateApproches(newData) {        
      if(newData.station_type_name === "Midblock"){
          let validateArray= [];          
          validateArray.push(newData.eb_approach,newData.wb_approach,newData.nb_approach,newData.sb_approach);
          var filterVal =  validateArray.filter((key,keyindex)=> key != ""
          )
          if((filterVal.length == 0) || (filterVal.length == 1) || (filterVal.length > 2)){
            return true;
          }else{
            return false;
          }
      }else{
        var aproach1=document.getElementById('intersection_Approaches_select_1').value;
        var aproach2=document.getElementById('intersection_Approaches_select_2').value;
        var aproach3=document.getElementById('intersection_Approaches_select_3').value;
        var aproach4=document.getElementById('intersection_Approaches_select_4').value;

        var aproachtext1=document.getElementById('intersection_Approaches_text_1').value.trim();
        var aproachtext2=document.getElementById('intersection_Approaches_text_2').value.trim();
        var aproachtext3=document.getElementById('intersection_Approaches_text_3').value.trim();
        var aproachtext4=document.getElementById('intersection_Approaches_text_4').value.trim();        

        if((aproach1 != '' && aproachtext1 =='') || (aproach2 != '' && aproachtext2 =='') || (aproach3 != '' && aproachtext3 =='') || (aproach4 != '' && aproachtext4 =='')){
            return true;
        }else{
            return false;
        }
      }
    }
    function validateApprochesOneAdded(newData) {        
          var aproach1=document.getElementById('intersection_Approaches_select_1').value;
          var aproach2=document.getElementById('intersection_Approaches_select_2').value;
          var aproach3=document.getElementById('intersection_Approaches_select_3').value;
          var aproach4=document.getElementById('intersection_Approaches_select_4').value;  
          var aproachtext1=document.getElementById('intersection_Approaches_text_1').value.trim();
          var aproachtext2=document.getElementById('intersection_Approaches_text_2').value.trim();
          var aproachtext3=document.getElementById('intersection_Approaches_text_3').value.trim();
          var aproachtext4=document.getElementById('intersection_Approaches_text_4').value.trim();        
  
          if((aproach1 == '' && aproachtext1 =='') && (aproach2 == '' && aproachtext2 =='') && (aproach3 == '' && aproachtext3 =='') && (aproach4 == '' && aproachtext4 =='')){
              return true;
          }else{
              return false;
          }
        
      }
    //This method is use for validate the approches  ... end

    //This method is use for API call to update station ... start
    const updateStation = (newData) => {
        setLoader(true);
        try {
            axios({
                method: 'post',
                data: newData,
                headers: {
                    'payload': Cookies.get('payload'),
                    'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.stationUpdateAPI + `${sessionStorage.getItem('viewStationId')}`,

            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        props.stationtabBack();
                    } else {
                        setErrMsgType('error')
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true)
                        setLoader(false);
                    }
                })
                .catch(function (error) {
                    if (error.response) {
                        setErrMsgType('error')
                        setErrMsg(error.response.data.message);
                        setErrPopUp(true)
                        setLoader(false);
                    } else {
                        setErrMsgType('error')
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true)
                        setLoader(false);
                    }
                })
        } catch (error) {
            setLoader(false);
        }
    }

    const handleClickOpen = (data, client_station_id, station_location, station_id) => {
        setSuccessMsg(false);
        setMyFileId(client_station_id);
        setFileName(station_location);
        setStationId(station_id)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const rejectFile = () => {
        try {
          axios({
            method: 'delete',
            url: API_URL + API_PATH.deleteStations + '/' + `${sessionStorage.getItem('viewStationId')}`,
            headers: {
              'payload': Cookies.get('payload'),
              'agencyid': sessionStorage.getItem('agency_id')
            },
          })
            .then(async function (response) {
              if (response.status && response.status == '200') {
                props.stationtabBack();
                setSuccessMsg(true);
              }
            })
            .catch(function (error) {
              console.log(error)
              setSuccessMsg(false);
            })
        } catch (error) {
          console.error(error);
          setSuccessMsg(false);
        }
        setOpen(false);
    }

    const handlePopUp = () => {
        setMapLayer(!getMapLayer);
    };

    const handleClick = (basemap) => { // callback method to set basemap
        setMapLayer(false);
        loadMap(basemap, lat, long);
        setCookie('stationDetailsMap', basemap);
    }

    return (
        <React.Fragment>
            <div className={classes.root}>
                <p style={{ marginBottom: '10px', marginTop: '0' }}><NavLink to="#" style={{ color: '#24618E' }} onClick={props.stationtabBack}><FontAwesomeIcon icon={faAngleLeft} />&nbsp;Return to Station List</NavLink></p>
                <form className={classes.rootForm} noValidate autoComplete="off" onSubmit={e => validateForm(e)} data-testid='station_details_from'>
                    <Grid container spacing={3}>
                        {/* Left Side Code Start */}
                        <Grid item xs={12} sm={6}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={5}>
                                    <h5>Station Details</h5>
                                </Grid>
                                <Grid item xs={12} sm={7}>
                                    <div className={classes.btbBlock}>
                                        <Button variant="outlined" id="cancel_btn" data-testid='cancel_btn_up' className={classes.cancelBtn} onClick={() => { clearStationForm() }}>
                                            Cancel</Button>&nbsp;&nbsp;
                                        <Button type="submit" variant="outlined" id="add_Station_btn" data-testid='update_Station_btn_up' className={classes.addStationBtn}>
                                            Save</Button>
                                    </div>
                                    <p style={{ marginTop: '10px', marginBottom: '0px', width: '100%', float: 'right', textAlign: 'right' }}>Required fields are marked with an asterisk (*)</p>
                                </Grid>
                            </Grid>
                            <fieldset className={classes.fieldsetname} style={{ marginTop: '-15px' }}>
                                {errMsg ? <div className={classes.approachError}>  <ErrorMessage message={errMsg} visible={ShowErrPopUP} show={errPopUp} msgType={errMsgType} /> </div> : null}
                                <legend>General</legend>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Station Type *</label>
                                            {!getEnableFlag ? <select id="station_Type" name="station_Type" className={classes.selectOption} onChange={showInterractionApproches} disabled={true} style={{ backgroundColor: '#F2F2F2' }} data-testid='station_type'>
                                                <option value={stationType} selected={true}>{stationTypeName}</option>
                                            </select> :
                                                <select id="station_Type" name="station_type" data-testid='station_type' className={classes.selectOption} onChange={showInterractionApproches} defaultValue={stationType}>
                                                    <option value="">Select</option>
                                                    {stationTypeValue.length > 0 &&
                                                        stationTypeValue.map((value, index) => {
                                                            return <option selected={value.id == stationType} value={value.id}>{value.station_type}</option>
                                                        })

                                                    }
                                                </select>}
                                        </Paper>
                                        {/* <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Station Type *</label>
                                             <select id="station_Type" name="station_Type" className={classes.selectOption} onChange={showInterractionApproches} disabled={!getEnableFlag} style={{ backgroundColor: '#F2F2F2' }} data-testid='station_type'>
                                                <option value={stationType} selected={true}>{stationTypeName}</option>
                                            </select> 
                                        </Paper> */}
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Station Privacy</label>
                                            <select id="station_Privacy" name="station_Privacy" className={classes.selectOption} onChange={handleChange('station_privacy')} data-testid='station_privacy'>
                                                <option value={1} selected={stationPrivacy == 1 ? true : false}>Public</option>
                                                <option value={2} selected={stationPrivacy == 2 ? true : false}>Private</option>
                                            </select>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Station Location *</label>
                                            <TextField id="station_Location" name="station_Location" className={classes.formInput} placeholder="Station Location *" type="text" variant="outlined" value={stationLocation} required data-testid='station_location' onChange={handleChange('station_location')} />
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Display Name (if different than Station Location)</label>
                                            <TextField id="display_name" name="display_name" className={classes.formInput} placeholder="Display Name" type="text" variant="outlined" required value={displayName} onChange={handleChange('display_name')} data-testid='display_name' />
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Station ID *</label>
                                            <TextField id="station_id" name="client_station_id" data-testid='client_station_id' className={classes.formInput} placeholder="Station ID *" type="text" variant="outlined" required value={stationId} onChange={handleChange('client_station_id')} />
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Status</label>
                                            <select id="status_check" name="status_check" data-testid='status' className={classes.selectOption} onChange={handleChange('status')}>
                                                <option value="active" selected={status == 'active' ? true : false}>Active</option>
                                                <option value="inactive" selected={status == 'inactive' ? true : false}>Inactive</option>
                                            </select>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Latitude *</label>
                                            <TextField id="latitude" name="latitude" data-testid='latitude' className={classes.formInput} placeholder="Latitude *" type="text" variant="outlined" value={lat} required onChange={handleChange('latitude')} />
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Longitude *</label>
                                            <TextField id="longitude" name="longitude" data-testid='longitude' className={classes.formInput} placeholder="Longitude *" type="text" variant="outlined" value={long} required onChange={handleChange('longitude')} />
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>State</label>
                                            <TextField id="state_code" name="state_code" data-testid='state_code' style={{ backgroundColor: '#F2F2F2' }} className={classes.formInput} placeholder="State *" type="text" variant="outlined" value={agencyState} required disabled={true} />
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>County</label>
                                            <TextField id="county" name="fips_county_code" data-testid="fips_county_code" style={{ backgroundColor: '#F2F2F2' }} className={classes.formInput} placeholder="County *" type="text" variant="outlined" value={county} disabled={true} />
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Jurisdiction</label>
                                            <TextField id="jurisdiction" name="jurisdiction" data-testid="jurisdiction" className={classes.formInput} placeholder="Jurisdiction" type="text" variant="outlined" value={jurisdiction} onChange={handleChange('jurisdiction')}>
                                            </TextField>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Community</label>
                                            <TextField id="community" name="community" data-testid="community" className={classes.formInput} placeholder="Community" type="text" variant="outlined" required value={community} onChange={handleChange('community')} />
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            {stationTypeName == 'Midblock' ?
                                                <><label className={classes.labelText}>Speed Limit</label>
                                                    <TextField id="speed_Limit" name="speed_Limit" data-testid="speed_limit" className={classes.formInput} placeholder="Speed Limit" type="tel" variant="outlined" required value={speedLimit} onChange={handleChange('speed_limit')} />
                                                </>
                                                : null}
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Description</label>
                                            <TextField id="description" name="description" data-testid="description" className={classes.formInput} placeholder="Description" type="tel" variant="outlined" required value={description} onChange={handleChange('description')} />
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </fieldset>                            
                        </Grid>
                        {/* Left Side Code End */}

                        {/* Right Side Code Start */}
                        <Grid item xs={12} sm={6}>
                            <div className={classes.mapViewSection}>
                                <Grid container spacing={3}>

                                    <Grid item xs={12} sm={12} style={{ padding: '0', border: '2px solid #246183', background: '#D7D7D7', overflow: 'hidden' }}>
                                        <Paper className={classes.paper} style={{ background: '#D7D7D7', position: 'relative' }}>
                                            {/* This Code Just Information to click    */}
                                            <div className={classes.rightClickInfo}>Drag the station icon to update its location</div>
                                            {/* This Code Just Information to click    */}
                                            <div className={classes.locationMapView}>
                                                <div ref={mapRef} className={classes.mapContainer} data-testid='mapView'>
                                                    <Box display='flex' flexDirection="column" className={classes.iconBox}>
                                                        <div className={classes.homeIcon} title="Home">
                                                            <FontAwesomeIcon icon={faHome} onClick={() => homeEvent()} title="Home" />
                                                        </div>
                                                        <div className={classes.zoomIcon} style={{ marginBottom: '-3px' }} title="Zoom In">
                                                            <FontAwesomeIcon icon={faPlus}
                                                                onClick={() => ZoomInEvent()} title="Zoom In" />
                                                        </div>
                                                        <div className={classes.inIcon} title="Zoom Out">
                                                            <FontAwesomeIcon icon={faMinus}
                                                                onClick={() => zoomOutEvent()} title="Zoom Out" />
                                                        </div>
                                                    </Box>
                                                </div>
                                            </div>
                                        </Paper>
                                    </Grid>
                                    {
                                        approaches.length > 0 ?
                                            <Grid item xs={12} sm={12} style={{ paddingTop: '0px' }}>
                                                <Paper className={classes.paper}>
                                                    <div className={stationType == 2 ? 'hideMidBlock' : 'showMidBlock'}>
                                                    <fieldset className={classes.fieldsetname} style={{ paddingBottom: '0px' }}>
                                                    <legend>Approaches *</legend>
                                                    {approachError ? <div className={classes.approachError}> <ErrorMessage message={errMsg} visible={ShowErrPopUP} show={approachError} msgType={errMsgType} /></div> : null}
                                                    <div className={classes.interApprochMainBlock}>
                                                        <div className="inter-left" >
                                                            
                                                            <select id="mid_Approaches_select_1" 
                                                                name="mid_Approaches_select_1" 
                                                                data-testid="mid_Approaches_select_1" 
                                                                className={midApproachSelectOneErr ? classes.errorInput : classes.selectOption} 
                                                                disabled={!getEnableFlag || stationHasData ? true : false}
                                                                onChange={selectApproach}>
                                                                    <option value="">Select</option>
                                                                    <option value="EB">EB</option>
                                                                    <option value="NB">NB</option>
                                                                    <option value="SB">SB</option>
                                                                    <option value="WB">WB</option>
                                                            </select>
                                                        </div>
                                                        <div className="inter-right">
                                                            <TextField id="mid_Approaches_text_1" name="mid_Approaches_text_1" className={classes.formInput} type="text" variant="outlined" onChange={approachText} data-testid="mid_Approaches_text_1" />
                                                            {midApproachSelectOneErr ? <FontAwesomeIcon icon={faExclamationCircle} className={classes.errIcon} /> : null}
                                                        </div>
                                                    </div>
                                                    <div className={classes.interApprochMainBlock}>
                                                        <div className="inter-left">
                                                            <select id="mid_Approaches_select_2" 
                                                                    name="mid_Approaches_select_2" 
                                                                    className={midApproachSelectTwoErr ? classes.errorInput : classes.selectOption} 
                                                                    onChange={selectApproach}
                                                                    disabled={!getEnableFlag ? true : null} 
                                                                    data-testid="mid_Approaches_select_2">
                                                                <option value="">Select</option>
                                                                <option value="EB">EB</option>
                                                                <option value="NB">NB</option>
                                                                <option value="SB">SB</option>
                                                                <option value="WB">WB</option>
                                                            </select>
                                                        </div>
                                                        <div className="inter-right">
                                                            <TextField id="mid_Approaches_text_2" 
                                                            name="mid_Approaches_text_2" 
                                                            className={classes.formInput} 
                                                            type="text" variant="outlined" 
                                                            onChange={approachText} 
                                                            data-testid="mid_Approaches_text_2" />
                                                            {midApproachSelectTwoErr ? <FontAwesomeIcon icon={faExclamationCircle} className={classes.errIcon} /> : null}
                                                        </div>
                                                    </div>
                                                </fieldset>
                                                        
                                                    </div>
                                                    {/* -------------------------------------------------- */}
                                                    <div className={stationType == 1 ? 'hideInteraction' : 'showHideInteraction'}>
                                                   
                                                        <fieldset className={classes.fieldsetname} style={{ paddingBottom: '0px' }}>
                                                            <legend>Approaches *</legend>
                                                            {approachError ? <div className={classes.approachError}> <ErrorMessage message={errMsg} visible={ShowErrPopUP} show={approachError} msgType={errMsgType} /> </div> : null}
                                                            {approachErrorBlank ? <div className={classes.approachError}> <ErrorMessage message={errMsg} visible={ShowErrPopUP} show={approachErrorBlank} msgType={errMsgType} /> </div> : null}
                                                            
                                                            {                                                                
                                                                approaches.map((value, index) => {                                                                    
                                                                    let indexApproaches = {eb_approach:1,nb_approach:2,sb_approach:3,wb_approach:4};
                                                                    let objVal = Object.values(value);
                                                                    let objKey = Object.keys(value);
                                                                    //if(objVal[0] != ""){
                                                                        return (<div className={classes.interApprochMainBlock}>
                                                                            <div className="inter-left">
                                                                                <select id={'intersection_Approaches_select_' + [indexApproaches[objKey[0]]]} 
                                                                                    name={'intersection_Approaches_select_' + [indexApproaches[objKey[0]]]} 
                                                                                    className={classes.selectOption}  
                                                                                    style={{ backgroundColor: '#F2F2F2' }}
                                                                                    onChange={selectApproach} 
                                                                                    disabled={!getEnableFlag || stationHasData? true : false}
                                                                                    data-testid={'intersection_Approaches_select_' + [indexApproaches[objKey[0]]]} >
                                                                                    <option value="" selected={(objVal[0] =="")?true:false}>Select</option>
                                                                                    <option value="EB" selected={(objKey[0] == 'eb_approach' && objVal[0] !="")?true:false}>EB</option>
                                                                                    <option value="WB" selected={(objKey[0] == 'wb_approach' && objVal[0] !="")?true:false}>WB</option> 
                                                                                    <option value="NB" selected={(objKey[0] == 'nb_approach' && objVal[0] !="")?true:false}>NB</option>
                                                                                    <option value="SB" selected={(objKey[0] == 'sb_approach' && objVal[0] !="")?true:false}>SB</option>
                                                                                
                                                                                </select>
                                                                            </div>
                                                                            <div className="inter-right">                                                                                
                                                                                <TextField error={getErr.eb_approach == ""} 
                                                                                    id={"intersection_Approaches_text_" + [indexApproaches[objKey[0]]]} 
                                                                                    name={"intersection_Approaches_text_" + [indexApproaches[objKey[0]]]} 
                                                                                    style={{width:getErr.eb_approach === "" && "95%"}} 
                                                                                    className={classes.formInput} type="text" 
                                                                                    variant="outlined" 
                                                                                    defaultValue={objVal[0]} 
                                                                                    disabled={objVal[0] == '' && stationHasData? true : false}
                                                                                    onChange={approachText} 
                                                                                    data-testid={"intersection_Approaches_text_" + [indexApproaches[objKey[0]]]} />
                                                                                {getErr.eb_approach == "" && <FontAwesomeIcon icon={faExclamationCircle}  className={classes.errIcon}/>}
                                                                            </div>
                                                                        </div>)
                                                                    //}                                                                
                                                                })                                                                                                                               
                                                            }
                                                            {/* Additional Approcesh block */}
                                                        </fieldset>
                                                    </div>
                                                </Paper>
                                            </Grid>
                                            : null
                                    }

                                </Grid>
                            </div>
                        </Grid>
                        {/* Right Side Code Start */}
                        <div className={classes.btbBlock2}>
                            <Button variant="outlined" id="cancel_btn" data-testid="cancel_btn" className={classes.cancelBtn} onClick={() => { clearStationForm() }}>
                                Cancel</Button>&nbsp;&nbsp;
                            <Button type="submit" variant="outlined" id="update_Station_btn" data-testid="update_Station_btn" className={classes.addStationBtn}>
                                Save</Button>
                        </div>
                    </Grid>
                </form>
            </div>
        </React.Fragment>
    );
}
export default StationDetails;
//End StationDetails component code ....